/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  InitializeAppResponse,
  GenericErrorResponse,
} from './responses';

import {
  InitializeAppPayload
} from './requests';

import { ContentType, HttpClient, RequestParams } from './httpClient';

export class App<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags App
   * @name initialize
   * @request POST:/app/initialize
   * @response `200` `InitializeAppResponse` Success
   */
  initialize = (data: InitializeAppPayload, params: RequestParams = {}) =>
    this.request<InitializeAppResponse, GenericErrorResponse>({
      path: '/one/initialize',
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      secure: true,
      ...params,
    });
}
